import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'

class OrderInvoice extends React.Component {
  constructor (props) {
    super (props)

    this.state = {
      attraction: 0
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { data_single } = nextProps.order

    if (data_single.order_details && data_single.order_details.length) {
      let attraction = 0
      data_single.order_details.forEach((data, i) => {
        if (data.type === 'attraction') {
          attraction++
        }
      })
      this.setState({ attraction })
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = (id = this.props.detail.id) => {
    this.props.getData(id)
  }

  _submit = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id,
      order_number: this.props.detail.order_number
    }
    this.props.downloadInvoice(data)
    this.props.closeModal()

    // if (this.state.attraction) {
    //   const data = {
    //     id: this.props.detail.id,
    //     order_number: this.props.detail.order_number
    //   }
    //   this.props.downloadInvoice(data)
    //   this.props.closeModal()
    // }
  }

  render() {
    const { detail, order } = this.props
    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '20vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Download Invoice
            {(order.fetching || order.processing) && 
              <div className="badge badge-info ml-2">{order.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>

        <div className="form-group text-center">
          <label className="control-label">Order ID</label>
          <input type="text" style={{ textAlign: 'center' }} readOnly className="form-control" value={detail.order_number}/>
        </div>

        { !this.state.attraction &&
          <div className="form-group text-center">
            <div className="alert alert-warning">
              <strong>Warning</strong> <br/> Invoice cannot be downloaded! <br/>
              <small>Invoice can only be downloaded if there is an <em>attraction</em> in the order detail list</small>
            </div>
          </div>
        }

        <div className="text-center">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" disabled={ !this.state.attraction } className="btn btn-lg btn-primary">Download</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  downloadInvoice: (data) => dispatch(OrderActions.orderInvoiceRequest(data)),
  getData: (id) => dispatch(OrderActions.orderSingleRequest(id)),
})

export default connect(stateToProps, dispatchToProps)(OrderInvoice)



// WEBPACK FOOTER //
// ./src/Containers/Order/OrderInvoice.js